import React from 'react';

function BackgroundLogin() {
  return (
    <div className="background-login-container">
      <div className="background-animation">
        <div className="circle circle1" />
        <div className="circle circle2" />
        <div className="circle circle3" />
        <div className="circle circle4" />
      </div>
    </div>
  );
}

export default BackgroundLogin;
